// extracted by mini-css-extract-plugin
export default {"thankyou":"Thankyou_thankyou__9BHfS","thankyou1":"Thankyou_thankyou1__vs1fr","thankyou123":"Thankyou_thankyou123__hiznP"};